module.exports = __webpack_public_path__ + "assets/img/binding-3.105775c2.jpg";